<template>
    <div class="tab-content-container">
        <Row type="flex" justify="center" align="top">
            <Col flex="auto" >
            <div ref="uipEcharts" :style="{ width: chartWidth, height: '550px' }"></div>
            </Col>
            <Col flex="220px" class="desc-row" >
            <Row type="flex" class="normal-row">
                <Col flex="1">{{ getTranslation('s305') }}&nbsp;<Select @on-change="getData" :transfer="true"
                    class="input-field" style="width:100px" :placeholder="getTranslation('m034')"
                    :not-found-text="getTranslation('b038')" v-model="timeRange">
                    <Option v-for="item in timeList" :value="item.value" :key="item.value">
                        {{ item.text }}</Option>
                </Select></Col>
            </Row>
            <Row type="flex" class="normal-row">
                <Col flex="1">{{ getTranslation('b006') }}&nbsp;<Input type="number" @on-change="changePid()"
                    v-model="pid" style="width: 80px"></Input></Col>
            </Row>
            <Row type="flex">
                <Col flex="1">{{ getTranslation('k099') }}&nbsp;<Input type="number" v-model="size"
                    style="width: 80px"></Input></Col>
            </Row>
            </Col>
        </Row>
    </div>
</template>
<script>
import { Row, Col, Input, Select, Option } from "view-design"
import { API_URL } from '@/constants/const';
import axios from 'axios';
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
    name: 'UipLine', // 组件名称
    components: {
        Row, Col, Input, Select, Option
    },
    props: {
    },
    data() {
        return {
            data: {},
            pid: 0,
            mac: 0,
            size: 100,
            chartWidth: '100%',
            myChart: null,
            timeRange: 30,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        timeList() {
            return [
                {
                    "value": 30,
                    "text": this.getTranslation('s306')
                },
                {
                    "value": 60,
                    "text": this.getTranslation('s307')
                },
                {
                    "value": 90,
                    "text": this.getTranslation('s308')
                }
            ]
        }
    },
    watch: {

    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac;
            this.pid = localStorage.getItem('system.uip.prgid') || 0;
            this.size = localStorage.getItem('system.uip.size') || 100;
            this.timeRange = parseInt(localStorage.getItem('system.uip.time_range')) || 30;
            this.initEcharts();
            this.getData();
        },
        initEcharts() {
            this.$nextTick(() => {
                const parentWidth = this.$refs.uipEcharts.offsetWidth;
                this.chartWidth = `${parentWidth}px`;
                this.myChart = this.$echarts.init(this.$refs.uipEcharts);
            })
        },
        getData() {
            let url = API_URL["systemUipHistory"];
            let params = {
                mac: this.mac,
                pid: this.pid,
                size: this.size,
                time_range: this.timeRange,
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        localStorage.setItem('system.uip.time_range', this.timeRange);
                        localStorage.setItem('system.uip.prgid', this.pid);
                        localStorage.setItem('system.uip.size', this.size);
                        let items = res.data.data.curves || [];

                        this.refreshChartUIPRecord(items, res.data.data.markArea);
                        this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        refreshChartUIPRecord(items, markArea) {

            let dataDip = [];
            let dataExpu = [];// 有飞溅
            if (Array.isArray(items)) {
                let dipArray = null; // dip数据
                let expuArray = null;  // 飞溅
                for (let jj = 0; jj < items.length; jj++) {
                    let curv = items[jj];
                    if (curv && curv.id === 1) { // 分类为UIP值
                        dipArray = items[jj].data;
                    } else if (curv && curv.id === 2) {
                        expuArray = items[jj].data;
                    }
                }

                if (Array.isArray(dipArray) && Array.isArray(expuArray) && expuArray.length === dipArray.length) {
                    let idx = 0;
                    let expu = undefined;
                    for (let kk = dipArray.length - 1; kk >= 0; kk--) {
                        dataDip.push([idx, dipArray[kk]]);
                        if (expu !== undefined && expu !== expuArray[kk]) {
                            dataExpu.push([idx, dipArray[kk]]); //添加一样的x/y坐标
                        }
                        expu = expuArray[kk];// 记录上一条的飞溅值
                        idx = idx + 1;
                    }
                }
            }

            let uipOption = {
                title: {
                    text: "weld-uip-curve",
                    show: false
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                grid: {
                    left: '45px',
                    right: '45px',
                    top: '20px'
                },
                xAxis: {},
                yAxis: {},
                series: [
                    {
                        symbolSize: 9,
                        data: dataDip,
                        itemStyle: {
                            color: '#4874CB'
                        },
                        type: 'scatter'
                    },
                    {
                        symbolSize: 8,
                        symbol: 'triangle',
                        data: dataExpu,
                        itemStyle: {
                            color: '#F00'
                        },
                        type: 'scatter'
                    }
                ]
            }

            // 划区间
            if (markArea && markArea.y1 !== undefined && markArea.y2 !== undefined) {
                uipOption.series[0].markArea = {
                    data: [
                        [
                            {
                                yAxis: markArea.y1
                            },
                            {
                                yAxis: markArea.y2
                            }
                        ]
                    ]
                }
            }
            this.myChart.setOption(uipOption, true);
        },
        changePid() {
            this.getData();
        }

    },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css');

.desc-row {
    margin-top: 100px;
}

.normal-row {
    margin-bottom: 10px;
}
</style>